export default __webpack_public_path__ + "media/images/icons/list-solid-0daba6d53ad7d616ec8e80afdb910337.svg";